// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.buttons-wrapper[data-v-a96fef62] {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n}\n@media (max-width: 568px) {\n.buttons-wrapper[data-v-a96fef62] {\n    gap: 10px;\n    text-align: center;\n    justify-content: center;\n}\n}\n", ""]);
// Exports
module.exports = exports;
